import { Stack } from '@mui/material';
import ConfirmPassword from 'components/form/form-fields/confirm-password/confirm-password.component';
import Email from 'components/form/form-fields/email.component';
import FirstName from 'components/form/form-fields/first-name.component';
import LastName from 'components/form/form-fields/last-name.component';
import Password from 'components/form/form-fields/password/password.component';
import Form from 'components/form/form.component';
import MandatoryFieldsInstruction from 'components/form/mandatory-fields-instruction/mandatory-fields-instruction.component';
import IncButton from 'components/inc-button/inc-button.component';
import InputPhone from 'components/input-phone/input-phone.component';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useEditAccountVerification } from '../activation-page.hooks';
import TocAndPrivacy from 'components/toc-and-privacy/toc-and-privacy.component';

const ActivationPageForm = ({ data, status }) => {
  const { t } = useTranslation();
  const { mobileSignup } = useEditAccountVerification();

  const methods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    defaultValues: data,
  });

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = methods;

  const onSubmit = async formData => {
    await mobileSignup(formData);
  };

  return (
    <Stack
      data-testid="ActivationPageForm.Container"
      flex={1}
      justifyContent={{ xs: 'unset', md: 'center' }}
      width="100%"
    >
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <MandatoryFieldsInstruction />
          <FirstName register={register} errors={errors} />
          <LastName register={register} errors={errors} />
          <Email register={register} errors={errors} disabled={data?.email} />
          <Password />
          <ConfirmPassword />
          <InputPhone
            defaultValue={data?.phoneNumber}
            disabled={data?.phoneNumber}
          />

          <IncButton
            type="submit"
            data-testid="SmsSignupForm.CustomButton.Submit"
            fullWidth
            disabled={isSubmitting}
          >
            {status === 'SOCIAL'
              ? t('activationPage.socialButton')
              : t('activationPage.button')}
          </IncButton>

          <TocAndPrivacy
            description={
              status === 'SOCIAL'
                ? t('register.termsAndConditions.socialDescription')
                : t('register.termsAndConditions.activateDescription')
            }
          />
        </Form>
      </FormProvider>
    </Stack>
  );
};

export default ActivationPageForm;
